export const dateStringToYmdHM = (str) => {
  const tokens = str.split(/[\s\-:]/)
  return `${tokens[0]}-${tokens[1]}-${tokens[2]} ${tokens[3]}:${tokens[4]}`
}
